import type { ReactElement } from "react";
import { Outlet } from "react-router";

export const RouteAccessBoundary = ({
  isAllowed,
  renderFallback,
}: {
  isAllowed: boolean;
  renderFallback: () => ReactElement;
}) => (isAllowed ? <Outlet /> : renderFallback());
